module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-20.7853c7fd.jpg";